import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Feedback, FeedbacksData} from '../../services/type';
import {styles} from '../styles';
import FeedbacksEditor from 'feedback-system/components/feedbacks-editor';

interface Classes {
    card: string;
    content: string;
    actions: string;
    element: string;
    expand: string;
    expandOpen: string;
    arrow: string;
    icon: string;
    boldText: string;
    editor: string;
    message: string;
    rating: string;
    messageIcon: string;
}

interface Props {
    classes: Classes;
    id: number;
    feedbacks: FeedbacksData;
    feedback: Feedback;
}

interface State {
    expanded: boolean;
}

class MobileFeedbackCard extends React.Component<Props, State> {
    state = {
        expanded: false
    };

    handleExpandClick = () => {
        this.setState(state => ({expanded: !state.expanded}));
    }

    render() {
        const {classes, feedbacks, feedback} = this.props;
        const recipientName = `${feedbacks.profile.firstName} ${feedbacks.profile.lastName}`;

        return (
            <Card className={classes.card}>
                <CardContent className={classes.content}>
                    <Typography className={classes.element} component="p">
                        <span>
                            <span className={classes.boldText}>Author: </span>
                            <span>{`${feedback.author.firstName} ${feedback.author.lastName}`}</span>
                        </span>
                        <span className={classes.rating}>rating: {feedback.rating}</span>
                    </Typography>
                    <Typography component="p">
                        <span>
                            <span className={classes.boldText}>Recipient: </span>
                            <span>{recipientName}</span>
                        </span>
                    </Typography>
                </CardContent>
                <Collapse in={this.state.expanded} timeout="auto" unmountOnExit={true}>
                    <CardContent>
                        <span className={classes.message}>Message: </span>
                        <div className={classes.editor}>
                            <FeedbacksEditor feedback={feedback}/>
                        </div>
                    </CardContent>
                </Collapse>
                <CardActions className={classes.actions} disableActionSpacing={true}>
                    <IconButton
                        className={classnames(classes.expand, {
                            [classes.expandOpen]: this.state.expanded
                        })}
                        onClick={this.handleExpandClick}
                        aria-expanded={this.state.expanded}>
                        <ExpandMoreIcon/>
                    </IconButton>
                </CardActions>
            </Card>
        );
    }
}

export default withStyles(styles)(MobileFeedbackCard);
